function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M354.612 18.04c79.007 26.112 137.294 50.455 182.021 163.749 33.418 84.647 23.675 153.908 34.746 253.977 15.307 138.36 52.474 223.66 26.849 357.574-32.512 169.907-104.215 267.41-208.87 290.07-81.279 17.6-130.839-31.44-200.579-104.265C91.001 877.047 31.094 775.695 9.127 584.811-12.148 399.943.59 247.791 81.383 118.294 160.662-8.776 247.455-17.376 354.612 18.04z",
  fill: "#F4F6D8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M166.361 423.125a5.78 5.78 0 00-1.479 7.756c.105.169-.446.02.033.707.479.687.504.027.605.14 2.077 2.305 5.633 2.709 8.156.855a5.77 5.77 0 002.203-6.047c-.064-.262.624-.133.631-.563.003-.137-.219-.14-.271-.291-.265-.773-.929-1.811-1.219-2.186-.011-.015-.213-.472-.228-.481-.274-.144-.439.779-.673.564-2.111-1.945-5.39-2.195-7.758-.454zM151.789 414.042c-3.443-2.29-7.974-1.487-10.488 1.729-.165.212-.227-.554-.878.37s.196.649.099.829c-1.968 3.692-.857 8.371 2.641 10.698a7.757 7.757 0 008.655-.021c.303-.204.454.725 1 .536.175-.061.077-.342.245-.478.857-.692 1.868-2.013 2.21-2.553.013-.022.5-.488.503-.512.058-.412-1.185-.193-1.02-.588 1.497-3.568.316-7.825-2.967-10.01zM167.7 409.426c.45-1.852-.734-3.716-2.681-4.334-.128-.041.218-.183-.329-.33-.547-.146-.267.183-.368.168-2.071-.308-4.051.881-4.509 2.762-.356 1.461.306 2.929 1.558 3.788.148.102-.257.308-.071.518.059.068.173-.017.266.036.476.271 1.271.516 1.584.585.013.002.317.146.328.143.203-.036-.122-.548.092-.534 1.929.12 3.7-1.036 4.13-2.802z",
  fill: "#235544"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M253.243 509.837s-5.908-10.95-4.881-14.126c1.452-4.518 11.051-10.157 11.051-10.157",
  stroke: "#fff",
  strokeWidth: 1.407,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M340.229 494.282H308.28a15.674 15.674 0 01-11.091-4.597 15.678 15.678 0 01-4.589-11.094 15.68 15.68 0 0115.68-15.679h31.952a15.68 15.68 0 0114.487 21.683 15.683 15.683 0 01-14.49 9.687z",
  fill: "#53C0DA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M447.673 618.176l-28.93 24.075-94.599-100.687-94.708 100.898-28.601-24.432 94.863-103.112a38.648 38.648 0 0112.679-9.115 38.68 38.68 0 0144.228 9.115l95.068 103.258z",
  fill: "#235544"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M437.137 634.814c7.901-6.746 12.621-14.187 10.543-16.622-2.078-2.434-10.168 1.061-18.069 7.806-7.901 6.746-12.621 14.188-10.542 16.622 2.078 2.434 10.168-1.061 18.068-7.806z",
  fill: "#000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M433.578 626.014l17.454 21.191 36.465-39.202-37.978 20.774-6.972-8.336",
  fill: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M207.607 610.667s47.491-2.186 47.42-17.595c-.05-11.344-20.296-11.89-20.296-11.89",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M262.809 606.914s-21.514-14.824-28.21-9.054c-6.696 5.771 6.31 32.374 6.31 32.374M308.249 505.862s-11.609 19.992-.701 31.116c10.908 11.124 39.827-26.781 39.827-26.781M273.815 595.188s-4.358-26.989 17.573-40.378M252.546 561.821s40.834 24.524 41.756-4.676",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M452.535 631.38l3.829-9.909M457.59 629.272l3.829-9.909M462.885 626.709l3.829-9.909",
  stroke: "#fff",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M362.19 539.552s-41.529 5.07-31.327-36.484",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M229.469 642.432c2.078-2.434-2.642-9.876-10.543-16.621-7.901-6.746-15.991-10.241-18.069-7.807-2.078 2.435 2.642 9.876 10.543 16.622s15.99 10.241 18.069 7.806z",
  fill: "#000"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M214.919 625.902l-17.454 21.188L161 607.89l37.978 20.772 6.969-8.334",
  fill: "#000"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M195.962 631.267l-3.829-9.912M190.907 629.16l-3.829-9.912M185.612 626.597l-3.829-9.912",
  stroke: "#fff",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M362.286 588.829h-69.21a3.781 3.781 0 01-3.781-3.781v-53.267a3.78 3.78 0 013.781-3.781h15.817a3.79 3.79 0 013.067 1.57l3.024 4.164a3.778 3.778 0 003.067 1.57h44.232a3.781 3.781 0 013.781 3.781v45.963a3.783 3.783 0 01-1.105 2.673 3.772 3.772 0 01-2.673 1.108z",
  fill: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M340.119 548.51l14.171-22.952",
  stroke: "#F5BED7",
  strokeWidth: 1.969,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M348.753 497.07l12.697 18.205-21.686 35.12 17.12 11.428s30.41-37.46 27.546-50.9c-2.951-13.851-34.174-43.746-34.174-43.746M280.345 516.719l-8.722-14.937 22.457-10.902",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M300.669 529.278a14.31 14.31 0 01-11.322 14.3 14.306 14.306 0 01-16.17-8.44 14.308 14.308 0 1127.492-5.86z",
  fill: "#FFED80"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M307.548 464.074c-12.32.306-58.114 22.321-60.078 31.262-1.963 8.941 19.902 37.773 22.871 39.805 3.348 2.29 18.644 7.348 18.942 5.452.355-2.251-13.954-9.321-13.954-9.321s18.914 5.959 19.379 3.939c.489-2.127-18.344-10.331-18.344-10.331s14.956.914 14.745-.709c-.244-1.879-13.504-6.133-13.504-6.133",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeLinejoin: "bevel"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M339.483 457.547a13.118 13.118 0 01-25.959-2.915c.018-.825.112-1.646.281-2.453a13.113 13.113 0 015.624-8.409 13.101 13.101 0 019.934-1.908 13.12 13.12 0 018.338 5.727 13.11 13.11 0 011.785 9.958h-.003z",
  fill: "#FFE233"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M341.298 443.367a5.449 5.449 0 01-5.427 4.331 5.45 5.45 0 01-4.632-8.152 5.447 5.447 0 0110.059 3.821z",
  fill: "#000"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M332.773 440.019a3.319 3.319 0 01-6.555-.737c.004-.209.027-.417.07-.622a3.323 3.323 0 013.933-2.59 3.326 3.326 0 012.586 2.649c.079.431.072.872-.02 1.3h-.014z",
  fill: "#000"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M334.444 464.074s-2.672-.762-2.416-3.25",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M335.66 459.375c.008-1.248-.622-2.263-1.407-2.268-.785-.005-1.427 1.002-1.435 2.25-.008 1.248.622 2.263 1.407 2.268.784.005 1.427-1.002 1.435-2.25zM330.934 459.499c.008-1.247-.622-2.263-1.406-2.268-.785-.005-1.427 1.003-1.435 2.25-.008 1.248.622 2.263 1.406 2.268.785.005 1.427-1.002 1.435-2.25z",
  fill: "#000"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M318.467 453.155a4.769 4.769 0 01-5.195 3.748 4.765 4.765 0 01-4.233-4.809 4.77 4.77 0 01.102-.891 4.757 4.757 0 013.78-3.706 4.748 4.748 0 011.859.019 4.753 4.753 0 013.011 2.056 4.748 4.748 0 01.676 3.583z",
  fill: "#FFE233"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M337.314 447.556s-5.163 1.953-13.097-1.277l-2.186 7.619-4.782-2.161s-.366-4.738-5.019-4.054c0 0 1.482-8.896 7.033-9.549 9.664-1.136 16.841 4.524 18.051 9.422z",
  fill: "#000"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M431.586 624.326s-10.972-36.513-43.791-15.01M405.469 628.121s-18.85-46.421 5.239-50.079M365.201 553.943s22.681 7.273 22.594 20.082c-.087 12.81-16.973 17.218-16.973 17.218",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M294.213 588.829h68.366a3.782 3.782 0 003.404-2.135l16.036-33.167a3.784 3.784 0 00-.201-3.655 3.771 3.771 0 00-3.203-1.772h-68.366a3.777 3.777 0 00-3.404 2.135l-16.037 33.167a3.779 3.779 0 003.405 5.427z",
  fill: "#C6D13E"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M298.458 521.437s-4.327 3.376-3.635 5.022c.692 1.646 6.448.433 6.448.433",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeLinejoin: "bevel"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M204 345.109s6.589 14.57 12.387 17.677c5.799 3.106 13.128-1.609 20.815 1.531 7.687 3.14 8.234 9.266 9.962 17.59 1.727 8.325 19.726 10.927 19.726 10.927",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M217.139 360.262c.266-2.283-1.301-4.34-3.431-4.648-2.13-.309-4.115 1.235-4.381 3.517-.265 2.283 1.302 4.341 3.432 4.648 2.13.309 4.115-1.235 4.38-3.517z",
  fill: "#fff",
  stroke: "#EC7EB0",
  strokeWidth: 4
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M241.461 365.537c.265-2.282-1.302-4.339-3.432-4.646-2.13-.309-4.114 1.235-4.379 3.517-.266 2.283 1.301 4.34 3.431 4.648 2.13.308 4.115-1.235 4.38-3.518v-.001z",
  fill: "#fff",
  stroke: "#FFDB00",
  strokeWidth: 4
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M256.766 387.3c.265-2.284-1.302-4.34-3.432-4.649-2.13-.307-4.115 1.236-4.38 3.519-.265 2.283 1.301 4.34 3.432 4.648 2.13.307 4.115-1.236 4.38-3.518z",
  fill: "#fff",
  stroke: "#53C0DA",
  strokeWidth: 4
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M368.227 344.038c-7.628-9.747-24.914-9.014-33.552 0-6.322 6.597-4.902 13.597-3.355 22.255 2.067 11.569 4.849 26.336 17.614 25.324 11.315-.896 12.092-12.478 15.937-22.254 3.687-9.374 9.694-17.225 3.356-25.325z",
  fill: "#D1DA65"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M348.981 337s2.049 11.27 0 17.463c-2.636 7.972-16.703 17.463-16.703 17.463M371 349.907s-9.111 3.037-18.981 13.667c-9.871 10.63-9.111 27.333-9.111 27.333",
  stroke: "#fff"
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#about-science-mobile_svg__clip0_831_55533)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M422.053 389.926s.027.002.038.009l-.038-.009s21.153-12.105 39.332-5.683c21.15 7.461 25.362 25.069 25.607 27.275 0 0 .008.105.001.115-1.513 1.609-15.408 13.092-36.811 6.415-18.399-5.752-28.129-28.122-28.129-28.122z",
  fill: "#D2EEDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455.45 372.103a2.45 2.45 0 01.811 2.114 2.454 2.454 0 01-.911 1.652 2.457 2.457 0 01-3.463-.385 2.468 2.468 0 01.384-3.463 2.456 2.456 0 013.175.082h.004zM461.403 375.081c.234.291.342.659.301 1.033a1.421 1.421 0 01-.519.944 1.4 1.4 0 01-1.815-.045l-.165-.172a1.408 1.408 0 01.214-1.977 1.402 1.402 0 011.816.045l.164.171.004.001z",
  fill: "#4CBA78"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.201 380.77v33.415",
  stroke: "#53C0DA",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.967 385.082v27.682",
  stroke: "#FFDB00",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.48 382.338v30.967",
  stroke: "#53C0DA",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.992 399.588l.001 13.8",
  stroke: "#EC7EB0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M459.607 377.283a2.654 2.654 0 01-2.642-2.603 2.65 2.65 0 012.602-2.684h.043a2.644 2.644 0 01.039 5.287h-.042z",
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M479.952 351.703a2.296 2.296 0 012.108 1.401 2.291 2.291 0 01-2.074 3.182h-.037a2.292 2.292 0 01-.036-4.583h.039zm0-.703h-.051a2.999 2.999 0 00-2.054.923 3 3 0 00.032 4.174 2.999 2.999 0 002.067.893h.051a2.992 2.992 0 002.054-.924 2.993 2.993 0 00-.031-4.174 2.996 2.996 0 00-2.068-.892z",
  fill: "#000"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M494.879 551.773a2.645 2.645 0 01-1.897-4.481 2.628 2.628 0 011.857-.802h.042a2.642 2.642 0 01.04 5.283h-.042z",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M494.879 546.842a2.286 2.286 0 012.107 1.398 2.29 2.29 0 01-.461 2.487c-.209.217-.46.391-.736.511a2.299 2.299 0 01-.876.187h-.034a2.292 2.292 0 01-.034-4.583h.037-.003zm.003-.704h-.048a2.998 2.998 0 00-2.973 3.015 2.995 2.995 0 003.015 2.972h.051a2.995 2.995 0 002.971-3.016 2.996 2.996 0 00-3.016-2.971z",
  fill: "#000"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M315.664 604.444a2.656 2.656 0 01-2.639-2.603 2.644 2.644 0 012.6-2.684h.039a2.647 2.647 0 012.58 2.624 2.647 2.647 0 01-2.541 2.663h-.039z",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M315.664 599.509a2.29 2.29 0 012.11 1.399 2.285 2.285 0 01-.464 2.489 2.28 2.28 0 01-1.609.695h-.037a2.296 2.296 0 01-2.108-1.401 2.297 2.297 0 011.2-2.997c.276-.119.573-.182.874-.185h.034zm0-.704h-.048a3 3 0 00-2.884 3.017 2.994 2.994 0 002.929 2.973h.048a2.995 2.995 0 002.023-5.097 3.001 3.001 0 00-2.068-.893z",
  fill: "#000"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M173.108 561.871a2.644 2.644 0 112.504-1.798 2.633 2.633 0 01-2.504 1.798z",
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M173.105 556.936c.25-.001.497.041.732.124a2.294 2.294 0 011.438 2.904 2.295 2.295 0 01-3.063 1.371 2.29 2.29 0 01.893-4.399zm0-.703a2.997 2.997 0 00-2.98 2.508 2.992 2.992 0 002.021 3.33 2.99 2.99 0 002.901-.55 2.987 2.987 0 00.628-3.829 2.994 2.994 0 00-1.613-1.293 2.887 2.887 0 00-.957-.16v-.006z",
  fill: "#000"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M222.734 628.553l-3.499 2.449 2.449 3.499 3.499-2.449-2.449-3.499z",
  fill: "#fff"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M222.636 629.055l2.045 2.921-2.923 2.045-2.031-2.92 2.923-2.046h-.014zm.188-.979l-4.076 2.85 2.852 4.077 4.074-2.853-2.853-4.074h.003z",
  fill: "#000"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M122.254 437.347l-3.502 2.434 2.435 3.502 3.502-2.434-2.435-3.502z",
  fill: "#fff"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M122.427 437.532l2.046 2.923-2.921 2.046-2.045-2.924 2.92-2.045zm.175-.976l-4.074 2.85 2.85 4.074 4.077-2.853-2.853-4.074v.003z",
  fill: "#000"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M236.665 392.671l-3.285 2.73 2.73 3.285 3.284-2.73-2.729-3.285z",
  fill: "#fff"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M317.75 334.988l2.279 2.743-2.743 2.281-2.282-2.746 2.746-2.278zm.09-.988l-3.823 3.179 3.179 3.824 3.823-3.18L317.84 334z",
  fill: "#000"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M122.05 600.789l-7.05 5.858M521.693 474.762l-3.747-8.367M524.842 599.528l8.367-3.747M431.017 631.43l2.026-8.941M157.483 368.083l-4.643-7.236",
  stroke: "#000",
  strokeWidth: 0.844,
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "about-science-mobile_svg__clip0_831_55533"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(418 367)",
  d: "M0 0h69v69H0z"
})));

function SvgAboutScienceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 1087,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
}

export default __webpack_public_path__ + "static/about-science-mobile.89399c85.svg";
export { SvgAboutScienceMobile as ReactComponent };